export default{
  namespaced: true,
  state: {
    statuAcitve: sessionStorage.getItem('statuAcitve') || '1',
    noticeText: JSON.parse(sessionStorage.getItem('noticeText')) || {}
  },
  mutations: {
    setStatuAcitve (state, obj) {
      sessionStorage.setItem('statuAcitve', obj)
      state.statuAcitve = obj
    },
    setNoticeText (state, obj) {
      let json = JSON.stringify(obj)
      sessionStorage.setItem('noticeText', json)
      state.noticeText = obj
    }
  },
  actions: {

  }

}



// WEBPACK FOOTER //
// ./src/vuex/modules/bar/index.js